<template>
  <div class="content user-report">
    <div class="row">
      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="filters.valid"
            class="mid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions1"
            ref="dateRangePicker"
          >
          </el-date-picker>
        </p>
        <div class="pull-left search-button-reports">
          <div class="btn btn-icon btn-info" :title="$t('reports.filter')" @click="getData"><i class="ti-search"></i></div>
        </div>
      </div>
    </div>
    <div class="row">
    <!-- <div class="col-md-12 col-sm-12 col-xs-12 pad-bt-10">
      <router-link  class="btn btn-info" to="/reports"><i class="ti-arrow-left"></i> Back</router-link>
    </div> -->
    <div class="col-lg-4 col-md-5 col-sm-12 col-xs-12 details-height">
      <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              {{$t('reports.userDetails')}}
            </h4>
          </div>
          <div class=" card-content">
            <div class="row pad-bt-10">
              <div class="col-lg-5 col-sm-5 col-xs-12"><b>{{$t('customers.id')}}</b></div>
              <div class="col-lg-7 col-sm-7 col-xs-12">{{customer.id}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-5 col-sm-5 col-xs-12"><b>{{$t('customers.name')}}</b></div>
              <div class="col-lg-7 col-sm-7 col-xs-12">{{customer.firstname}} {{customer.lastname}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-5 col-sm-5 col-xs-12"><b>{{$t('customers.email')}}</b></div>
              <div class="col-lg-7 col-sm-7 col-xs-12">{{customer.email}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-5 col-sm-5 col-xs-12"><b>{{$t('customers.phone')}}</b></div>
              <div class="col-lg-7 col-sm-7 col-xs-12">{{customer.phone}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-5 col-sm-5 col-xs-12"><b>{{$t('customers.gender')}}</b></div>
              <div class="col-lg-7 col-sm-7 col-xs-12">{{customer.gender}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-5 col-sm-5 col-xs-12"><b>{{$t('customers.birth')}}</b></div>
              <div class="col-lg-7 col-sm-7 col-xs-12">{{formatDate(customer.birthdate)}}</div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-5 col-sm-5 col-xs-12"><b>{{$t('customers.address')}}</b></div>
              <div class="col-lg-7 col-sm-7 col-xs-12">
                <template v-if="customer.addresses && customer.addresses.length">
                  {{getUserAddress(customer.addresses[0])}}
                </template>
                <template v-else>
                  <b>-</b>
                </template>
              </div>
            </div>
            <div class="row pad-bt-10">
              <div class="col-lg-5 col-sm-5 col-xs-12"><b>{{$t('customers.pointsTitle')}}</b></div>
              <div class="col-lg-7 col-sm-7 col-xs-12">{{customer.loyalty_points}}</div>
            </div>
          </div>
          <div class="row card-footer">         
          </div>
      </div> <!-- end card -->
    </div> <!--  end col-md-12  -->
    
    <!-- Orders Chart -->
    <div class="col-lg-8 col-md-7 col-sm-12 col-xs-12 details-height">
      <chart-card
        v-loading="loading"
        :chart-data="ordersChart.data"
        :chart-options="ordersChart.options"
        ref="refOrdersChart"
      >
        <div slot="header">
          <h4 class="card-title">{{$t('reports.orderChart')}}</h4>
          <p class="category">{{ordersChart.title}}</p>
        </div>
        <div slot="footer">
          <div class="chart-legend">
            <i class="fa fa-circle text-info"></i>
            {{$t('dashboard.completed')}}
          </div>
        </div>
      </chart-card>
    </div>

    <div class="col-md-4 col-sm-12 charts-height">
      <chart-pie-card 
        v-loading="loading"
        :chart-data="paymentsChart.data"
        :chart-options="paymentsChart.options"
        ref="paymentsChart"
      >
        <div slot="header">
          <h4 class="card-title">{{$t('reports.cash')}} VS {{$t('reports.card')}}</h4>
          <p class="category">{{paymentsChart.title}}</p>
        </div>
        <div slot="footer">
          <div class="chart-legend">
          </div>
        </div>
      </chart-pie-card>
    </div>

    <div class="col-md-8 col-sm-12 charts-height">
      <chart-bars-card
        v-loading="loading"
        :chart-data="topProdsChart.data"
        :chart-options="topProdsChart.options"
        ref="topProdsChart"
      >
        <div slot="header">
          <h4 class="card-title">{{$t('reports.top5Chart')}}</h4>
          <p class="category">{{topProdsChart.title}}</p>
        </div>
        <div slot="footer">
          <div class="chart-legend">
            <i class="fa fa-circle text-info"></i>
            {{$t('reports.salesProductNr')}}
          </div>
        </div>
      </chart-bars-card>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="card">
        <form class="">
          <div class="card-header">
            <h4 class="card-title">
              {{$t('reports.salesDetails')}}
            </h4>
          </div>
          <div class="row card-content">
            <data-tables class=""
                    v-loading="loading"
                    :data="customer.orders"
                    :search-def="{show: false}"
                    :action-def="defaultActionDef()"
                    :pagination-def="paginationDef"
                    :table-props="{'border': false}"
                    @row-click="goToRecord"
                    style="width: 100%">
              <el-table-column
                :min-width="100"
                sortable
                prop="number"
                :label="$t('customers.number')">
                <template slot-scope="props">
                  <b>#{{props.row.token}}</b>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="150"
                sortable
                prop="date"
                :label="$t('customers.dateCreated')">
                <template slot-scope="props">
                  {{formatDateTime(props.row.created_at)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="150"
                sortable
                prop="delivery_type"
                :label="$t('customers.delivery')">
                <template slot-scope="props">
                  {{props.row.delivery_type ? $t('deliveryTypes.' + props.row.delivery_type) : '-'}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                sortable
                prop="order_type"
                :label="$t('customers.type')">
                <template slot-scope="props">
                  <span :class="'text-lowercase'">
                  {{$t('ordersTypes.' + props.row.order_type)}}
                </span>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                sortable
                prop="status"
                :label="$t('customers.status')">
                <template slot-scope="props">
                  <span :class="'label label-' + orderStatusClass(props.row.status.id)">{{$t('ordersStatus.' + props.row.status.id)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="100"
                :class="'text-right'"
                sortable
                prop="total"
                :label="$t('customers.total')">
                <template slot-scope="props">
                  <b>{{formatMoneyAmount(props.row.totals_grandtotal, props.row.currency)}}</b>
                </template>
              </el-table-column>
            </data-tables>
          </div>
          <div class="row card-footer">
          </div>
        </form>
      </div> <!-- end card -->
    </div> <!--  end col-md-12  -->

  </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import {Select, Option, DatePicker} from 'element-ui'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
  import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker,
      ChartCard,
      ChartBarsCard,
      ChartPieCard
    },
    created: function () {
      this.getData()
    },
    data () {
      return {
        loading: false,
        paginationDef: {
          pageSize: 99999,
          currentPage: 1,
          pageSizes: [99999],
          show: false
        },
        filters: {
          'valid': []
        },
        customer: [],
        modelValidations: {
          required: {
            required: true
          }
        },
        ordersChart: {
          title: '',
          data: {
            labels: [],
            series: []
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            },
            height: '200px'
          }
        },
        topProdsChart: {
          title: '',
          data: {
            labels: [],
            series: []
          },
          options: {
            seriesBarDistance: 20,
            showArea: true,
            height: '300px',
            axisX: {
              showGrid: false
            },
            axisY: {
              onlyInteger: true
            }
          }
        },
        paymentsChart: {
          title: '',
          data: {
            labels: [],
            series: []
          },
          options: {
            showArea: true,
            height: '300px',
            width: '300px'
          }
        },
        tableColumns: [
          {
            prop: 'number',
            label: 'Number',
            minWidth: 100
          },
          {
            prop: 'created_date',
            label: 'Date Created',
            minWidth: 150
          },
          {
            prop: 'delivery_service',
            label: 'Delivery',
            minWidth: 150
          },
          {
            prop: 'type',
            label: 'Type',
            minWidth: 100
          }
        ],
        pickerOptions1: {},
        pickerNames: ['date_from', 'date_to']
      }
    },
    methods: {
      getData () {
        this.loading = true
        const currency = this.getCompanyDetail('currency')
        this.currency = this.getCurrencySymbol(currency)
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          start_date: this.filters.valid ? this.filters.valid[0] : null,
          end_date: this.filters.valid ? this.filters.valid[1] : null
        }
        if (this.$route.params.id) {
          this.loading = true
          const id = this.$route.params.id
          this.apiRequest('/reports/clients/' + id, 'GET', data, response => {
            if (response.status === true) {
              if (!this.filters.valid || !this.filters.valid.length) {
                this.filters.valid = [moment(String(response.data[0].created_at)).format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
                this.$refs.dateRangePicker.$set(this.filters.valid)
              }
              this.customer = response.data[0]
              this.ordersChart.data.labels = response.data[0].orders_chart.labels
              this.ordersChart.data.series = response.data[0].orders_chart.series
              this.ordersChart.title = this.$t('reports.total') + ' ' + response.data[0].orders_count
              this.$refs.refOrdersChart.initChart()

              this.topProdsChart.data.labels = response.data[0].products_chart['labels']
              this.topProdsChart.data.series = [response.data[0].products_chart['values']]
              this.$refs.topProdsChart.initChart()

              let totalPayments = response.data[0].payments_chart.card + response.data[0].payments_chart.cash
              if (totalPayments) {
                this.paymentsChart.data.labels = [
                  this.$t('reports.card') + ' - ' + parseFloat(response.data[0].payments_chart.card * 100 / totalPayments).toFixed(2) + '%',
                  this.$t('reports.cash') + ' - ' + parseFloat(response.data[0].payments_chart.cash * 100 / totalPayments).toFixed(2) + '%'
                ]
                this.paymentsChart.data.series = [
                  {
                    value: response.data[0].payments_chart.card,
                    name: this.$t('reports.card')
                  },
                  {
                    value: response.data[0].payments_chart.cash,
                    name: this.$t('reports.cash')
                  }
                ]
                this.$refs.paymentsChart.initChart()
              }

              this.$nextTick(() => {
                this.loading = false
              })
            }
          })
        }
      },
      goToRecord (row, event, column) {
        window.open(`/#/orders/view/${row.id}`)
      }
    }
  }
</script>
<style scoped>
  .content {
    margin-top: 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ReportsCustomerDetails.vue